import { render, staticRenderFns } from "./user-add-or-update.vue?vue&type=template&id=d35a1da4"
import script from "./user-add-or-update.vue?vue&type=script&lang=js"
export * from "./user-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./user-add-or-update.vue?vue&type=style&index=0&id=d35a1da4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports